


















































import { getValueByType } from '../../core/api/ValuesHelper';
import { get } from 'http';
import Loading from 'vue-loading-overlay';
import { Component, Prop, Vue, Emit, Mixins } from 'vue-property-decorator';

@Component({
    components: { 
        Loading,
    }
})
export default class JourneyOTDetail extends Vue {
    @Prop({ default: {} }) otDetail: object;
    @Prop({ default: false }) visible: boolean;

    @Emit()
    closeModal() {}

    getParsedValue(value: any){
      return getValueByType(value);  
    }

    mounted(){
     
    }

    
}
